import { Icon, IconButton, Tooltip } from '@mui/material'
import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import Datetime from 'utils/datetime/datetime'

type TimePeriodPickerProps = {
  startTime: ISODateTime
  setTimePeriod: (startTime: ISODateTime, periodType?: `month` | `week`, timePeriodLength?: number) => void
  periodType?: `month` | `week`
  timePeriodLength?: number
}

function Capitalize(string: string): string {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export default function TimePeriodPicker({
  startTime,
  setTimePeriod,
  periodType = `month`,
  timePeriodLength = 0,
}: TimePeriodPickerProps): ReactElement {
  const { t } = useTranslation()

  let timePeriodFormat: 'monthYear' | 'week' | 'onlyDate' = 'onlyDate'
  let timeUnit = ''
  switch (periodType) {
    case `month`:
      timePeriodFormat = `monthYear`
      timeUnit = `month`
      timePeriodLength = 1
      break
    case `week`:
      timePeriodFormat = `week`
      timeUnit = `week`
      timePeriodLength = 1
      break
    default:
      timePeriodFormat = `onlyDate`
      timeUnit = `day`
      break
  }

  const addWeeks = Datetime.addWeeks(startTime, timePeriodLength)
  const subtractWeeks = Datetime.subtractWeeks(startTime, timePeriodLength)

  const addMonths = Datetime.addMonths(startTime, timePeriodLength)
  const subtractMonths = Datetime.subtractMonths(startTime, timePeriodLength)

  return (
    <>
      <Tooltip title={t(`Previous`)} arrow placement="top">
        <IconButton
          onClick={() => {
            setTimePeriod(periodType === 'week' ? subtractWeeks : subtractMonths, periodType, timePeriodLength)
          }}
          size="large"
        >
          <Icon className="fal fa-angle-left" fontSize="inherit" />
        </IconButton>
      </Tooltip>

      {`${timeUnit === 'week' ? `${t('Week')} ` : ''}${Capitalize(Datetime.toLocalTime(startTime, timePeriodFormat))}`}
      <Tooltip title={t(`Following`)} arrow placement="top">
        <IconButton
          onClick={() => {
            setTimePeriod(periodType === 'week' ? addWeeks : addMonths, periodType, timePeriodLength)
          }}
          size="large"
        >
          <Icon className="fal fa-angle-right" fontSize="inherit" />
        </IconButton>
      </Tooltip>
    </>
  )
}
